import React, { useEffect, useMemo, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ITEM_PER_PAGE, PUBLIC_URL, SEARCH_DELAY } from "../../app.config";
import Pagination from "../../component/Pagination";
import SearchAndExport from "../../component/SearchAndExport";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import useDebounce from "../hooks/useDebounce";
import * as API from "../../utils/api.service";
import {
  ExportToCSV,
  ExportToExcel,
  ExportToPdf,
  handleNoDataFound,
  SWIT_DELETE,
  SWIT_DELETE_SUCCESS,
} from "../../utils/common.service";
import {
  getSubscriptionApiCall,
  editSubscriptionApiCall,
} from "../../Store/slices/subscriptionSlice";
import { PermissionContext } from "../../context/PermissionContext";
import Cookies from "js-cookie";

export default function ManageSubscription() {
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const debounce = useDebounce(search, SEARCH_DELAY);
  const [page, setPage] = useState(1);
  const [fieldSort, setFieldSort] = useState("id desc");
  const [ascSort, setAscSort] = useState(false);
  const [sortColumn, setSortColumn] = useState("id");
  let userData = Cookies.get("dataCA")
    ? JSON.parse(Cookies.get("dataCA"))
    : null;
  const role = userData ? userData.role : null;
  const { permissions } = useContext(PermissionContext);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handleSortChange = (fieldName, sort) => {
    if (sort === "asc") {
      setFieldSort(`${fieldName} ${sort}`);
      setSortColumn(fieldName);
      setAscSort(true);
    } else {
      setFieldSort(`${fieldName} ${sort}`);
      setSortColumn(fieldName);
      setAscSort(false);
    }
  };

  const {
    subscriptionList: { data: subscriptionList },
  } = useSelector((state) => state.subscription);

  //console.log("subscriptionList :", subscriptionList);

  useEffect(() => {
    handleCompanyListAPI();
  }, [page, debounce, fieldSort]);

  const handleCompanyListAPI = () => {
    let submitData = {
      search: debounce,
      page: page,
      fieldSort,
    };
    // let request = {};
    dispatch(getSubscriptionApiCall(submitData));
  };

  const handleStatusChange = async (id, currentStatus) => {
    //console.log("currentStatus :", currentStatus);
    dispatch(setLoader(true));
    const newStatus = currentStatus === "Active" ? "Inactive" : "Active";

    let submitData = { id, status: newStatus };

    try {
      const { code } = await API.updateSubscriptionStatusApi(submitData);
      if (code == "1") {
        dispatch(
          getSubscriptionApiCall({
            search: debounce,
            page: page,
            fieldSort: fieldSort,
          })
        );

        SWIT_DELETE_SUCCESS(`Status changed to ${newStatus} successfully`);
      } else {
        console.log("error");
        
      }
    } catch (error) {
      console.error("Error changing status:", error);
    } finally {
      dispatch(setLoader(false));
    }
  };

  const handleDeleteManage = async (id) => {
    SWIT_DELETE(`You won't be able to delete this!`).then(async (result) => {
      if (result?.isConfirmed) {
        dispatch(setLoader(true));
        let submitData = {
          id: id,
          status: "Deleted",
        };

        // console.log(
        //   "444444444444444444444444444444444444444444444444444444",
        //   submitData
        // );

        const { code } = await API.updateSubscriptionStatusApi(submitData);
        if (code == "1") {
          await handleCompanyListAPI();
          await SWIT_DELETE_SUCCESS(`Subscription delete successfully`);
        }
      }
    });
  };

  // const handleExportApiCall = async (type) => {
  //   dispatch(setLoader(true));
  //   let submitData = {
  //     search: debounce,
  //     fieldSort,
  //   };
  //   const { code, data } = await API.getClientExportListApi(submitData);
  //   if (code === "1") {
  //     if (type === "PDF") {
  //       ExportToPdf(data, "clientList", "Client List");
  //     } else if (type === "CSV") {
  //       ExportToCSV(data, "clientList");
  //     } else if (type === "EXCEL") {
  //       ExportToExcel(data, "clientList");
  //     }
  //   }
  //   dispatch(setLoader(false));
  // };

  // console.log("*****************************************",clientList);
  const companyListData = useMemo(() => {
    return subscriptionList?.map((item, index) => (
      <>
        <tr key={index}>
          <td>{item?.id}</td>
          <td>{item?.name}</td>
          <td>{item?.name_ar}</td>
          <td>{item?.validity_days}</td>
          <td>{item?.free_trial_days}</td>
          <td>{item?.max_student}</td>
          <td>{item?.price}</td>
          <td>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id={`is_active_${item.id}`}
                checked={item?.status === "Active"}
                onChange={(e) => {
                  // console.log("e--------------------", e.target.value);
                  handleStatusChange(item?.id, item?.status);
                }}
              />
            </div>
          </td>

          <td>
            <a
              className="text-reset fs-18 m-1 cursor_pointer"
              onClick={() =>
                navigate(`/manage_subscription/add_subscription`, {
                  state: { subscriptionData: item },
                })
              }
            >
              <i className="ri-edit-line"></i>
            </a>

            <a
              className="text-reset fs-18 cursor_pointer"
              onClick={() => handleDeleteManage(item?.id)}
            >
              <i className="ri-delete-bin-6-line"></i>
            </a>
          </td>
        </tr>
      </>
    ));
  }, [subscriptionList]);

  return (
    <>
      <div className="content">
        <div className="container-fluid">
          <SubNavbar title={`Manage Subscription`} header={`Subscription`} />

          <div className="card rounded-3">
            <div className="card-body">
              <div className="rounded-3 mb-3">
                <SearchAndExport
                  searchFieldName={`Subscription`}
                  setSearch={setSearch}
                  isExport={false}
                  buttonName={`Add Subscription`}
                  navigatePath={`/manage_subscription/add_subscription`}
                  // handleExportApiCall={handleExportApiCall}
                />
              </div>
              <div className="responsive-table-plugin">
                <div className="table-rep-plugin">
                  <div
                    className="table-responsive"
                    data-pattern="priority-columns"
                  >
                    {Object.keys(subscriptionList)?.length > 0 ? (
                      <>
                        <table
                          id="tech-companies-1"
                          className="table table-centered mb-0 table-hover "
                        >
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                className={`cursor_pointer bi ${
                                  sortColumn === "id"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "id",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Id
                              </th>

                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "name"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "name",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Plan Name
                              </th>
                              <th
                                className={`cursor_pointer bi ${
                                  sortColumn === "name_ar"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "name_ar",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Plan Arebic Name
                              </th>

                              <th>Duration</th>
                              <th>Free Tryle Duration</th>
                              <th>Maximum Student</th>
                              <th>Price</th>

                              <th
                                scope="col"
                                className={`cursor_pointer bi ${
                                  sortColumn === "status"
                                    ? ascSort
                                      ? "bi-caret-up"
                                      : "bi-caret-down"
                                    : ""
                                }`}
                                onClick={() =>
                                  handleSortChange(
                                    "status",
                                    ascSort ? "desc" : "asc"
                                  )
                                }
                              >
                                Status
                              </th>

                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{companyListData}</tbody>
                        </table>
                      </>
                    ) : (
                      <>{handleNoDataFound("Subscription Plan")}</>
                    )}
                  </div>
                  <Pagination
                    per_page={ITEM_PER_PAGE}
                    pageCount={subscriptionList[0]?.subscription_count}
                    onPageChange={handlePageChange}
                    page={page}
                    lableName={`Challenges`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
